import appFactory from './appFactory'

var _options = {}

function config(options) {
	Object.assign(_options, options)
}

config.current = _options

export default config